module.exports = __webpack_public_path__ + "img/click_tab.44ea7dbc.png";